import { useContext } from '@nuxtjs/composition-api';
import { Logger } from '~/helpers/logger';
import DOMPurify from 'isomorphic-dompurify';
import { mapValues } from "lodash-es";

export const useNews = () => {
  const context = useContext();

  const getNewsTypes = async () => {
    Logger.debug('useNews/getNewsTypes');

    const data = await context.app.$vsf.$magento.api.getNewsTypes();
    Logger.debug('[Result]:', { data });

    return data?.data;
  };
  const getNewsList = async (params) => {
    const queryVariables = mapValues(params, (value) => DOMPurify.sanitize(value));
    Logger.debug('useContact/getNewsList');

    const data = await context.app.$vsf.$magento.api.getNews({ queryVariables });

    Logger.debug('[Result]:', { data });
 
    return data?.data;
  };

  return {
    getNewsTypes,
    getNewsList,
  };
};

export default useNews;
